
import React, { useEffect, useState, useRef, } from "react";
import {
    Row,
    Col,
    Form,
    Input,
    Switch,
    Select,
    useCRUDController,
    InputNumber,
    Textarea
} from '../../ui/ot'
import { useTranslation } from "react-i18next";
import { Card, CardHeader, CardTitle, CardDescription, CardContent } from "../../ui/card";

/* ── Icons for Card headers (簡編 cards mode) ── */
const IconClipboardCheck = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path fillRule="evenodd" d="M10.854 7.146a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708 0l-1.5-1.5a.5.5 0 1 1 .708-.708L7.5 9.793l2.646-2.647a.5.5 0 0 1 .708 0"/>
        <path d="M4 1.5H3a2 2 0 0 0-2 2V14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V3.5a2 2 0 0 0-2-2h-1v1h1a1 1 0 0 1 1 1V14a1 1 0 0 1-1 1H3a1 1 0 0 1-1-1V3.5a1 1 0 0 1 1-1h1z"/>
        <path d="M9.5 1a.5.5 0 0 1 .5.5v1a.5.5 0 0 1-.5.5h-3a.5.5 0 0 1-.5-.5v-1a.5.5 0 0 1 .5-.5zm-3-1A1.5 1.5 0 0 0 5 1.5v1A1.5 1.5 0 0 0 6.5 4h3A1.5 1.5 0 0 0 11 2.5v-1A1.5 1.5 0 0 0 9.5 0z"/>
    </svg>
);
const IconFileEarmarkText = ({ size = 16, ...props }) => (
    <svg xmlns="http://www.w3.org/2000/svg" width={size} height={size} fill="currentColor" viewBox="0 0 16 16" {...props}>
        <path d="M5.5 7a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1zM5 9.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5m0 2a.5.5 0 0 1 .5-.5h2a.5.5 0 0 1 0 1h-2a.5.5 0 0 1-.5-.5"/>
        <path d="M9.5 0H4a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2V4.5zm0 1v2A1.5 1.5 0 0 0 11 4.5h2V14a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1z"/>
    </svg>
);

const GeneralBibliographicEditModeForm = ({
    propsForm,
    field,
    onFormFinish = () => { },
    keyPrefix = "cataloging.bibliographic_management",
    catalogType = "book",  // "book" | "serial"
    section,               // "required" | "optional" — 篩選顯示哪些欄位
}) => {

    const [form_] = Form.useForm();
    const form = propsForm ? propsForm : form_
    const [count, setCount] = useState(0);
    const axiosMode = Form.useWatch([field?.name ?? '', 'axiosMode'].join('.'), form)

    const setDataInitialization = () => {
        //拿個下拉選單等等的資訊

    };
    const onFinish = (values) => {
        onFormFinish({
            ...values,
        });

    };
    const onValuesChange = (value, { name, type }) => {

        let formValues = null;
        formValues = form.getFieldsValue();
    };


    const getAnyFormValue = (name, count) => {
        let formValues = null;
        formValues = form.getFieldValue(name);
        return formValues;
    };

    useEffect(() => {
        setDataInitialization();
    }, []);


    // 如果有 section（簡編模式），表示父層已包裹 <Form>，不需再包一層
    if (section) {
        return (
            <FormItemComponent
                axiosMode={axiosMode}
                field={field}
                getAnyFormValue={getAnyFormValue}
                count={count}
                setFieldValue={form.setFieldValue}
                setCount={setCount}
                keyPrefix={keyPrefix}
                catalogType={catalogType}
                section={section}
            />
        );
    }

    return (
        <Row>
            <Col span={24}>
                <Form
                    form={propsForm ? propsForm : form}
                    onValuesChange={onValuesChange}
                    onFinish={onFinish}
                    autoComplete="off"

                >
                    <Row>
                        <Col span={24}>
                            <FormItemComponent
                                axiosMode={axiosMode}
                                field={field}
                                getAnyFormValue={getAnyFormValue}
                                count={count}
                                setFieldValue={form.setFieldValue}
                                setCount={setCount}
                                keyPrefix={keyPrefix}
                                catalogType={catalogType}
                                section={section}
                            />
                        </Col>
                    </Row>

                </Form >
            </Col >
        </Row >
    );
};
const FormItemComponent = ({
    field,
    initialValues = {},
    keyPrefix = "cataloging.bibliographic_management",
    axiosMode,
    getAnyFormValue,
    catalogType = "book",
    section,               // "required" | "optional"

}) => {
    const { t } = useTranslation('translation', { keyPrefix })
    let columns = [
        {
            title: t("bib_biblionumber"),
            key: "bib_biblionumber",
            dataIndex: "bib_biblionumber",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_notes"),
            key: "bib_notes",
            dataIndex: "bib_notes",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_copyrightdate"),
            key: "bib_copyrightdate",
            dataIndex: "bib_copyrightdate",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_datecreated"),
            key: "bib_datecreated",
            dataIndex: "bib_datecreated",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_seriestitle"),
            key: "bib_seriestitle",
            dataIndex: "bib_seriestitle",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_biblioitemnumber"),
            key: "bibitem_biblioitemnumber",
            dataIndex: "bibitem_biblioitemnumber",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_volume"),
            key: "bibitem_volume",
            dataIndex: "bibitem_volume",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_itemtype"),
            key: "bibitem_itemtype",
            dataIndex: "bibitem_itemtype",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_itemtype_description"),
            key: "bibitem_itemtype_description",
            dataIndex: "bibitem_itemtype_description",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_isbn"),
            key: "bibitem_isbn",
            dataIndex: "bibitem_isbn",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_publishercode"),
            key: "bibitem_publishercode",
            dataIndex: "bibitem_publishercode",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_editionstatement"),
            key: "bibitem_editionstatement",
            dataIndex: "bibitem_editionstatement",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_illus"),
            key: "bibitem_illus",
            dataIndex: "bibitem_illus",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_pages"),
            key: "bibitem_pages",
            dataIndex: "bibitem_pages",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_notes"),
            key: "bibitem_notes",
            dataIndex: "bibitem_notes",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_size"),
            key: "bibitem_size",
            dataIndex: "bibitem_size",
            align: "center",
            sorter: false
        },
        {
            title: t("bibitem_place"),
            key: "bibitem_place",
            dataIndex: "bibitem_place",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_cover_images"),
            key: "bib_cover_images",
            dataIndex: "bib_cover_images",
            align: "center",
            sorter: false
        },
        {
            title: t("items_count"),
            key: "items_count",
            dataIndex: "items_count",
            align: "center",
            sorter: false
        },
        {
            title: t("items_borrowed_count"),
            key: "items_borrowed_count",
            dataIndex: "items_borrowed_count",
            align: "center",
            sorter: false
        },
        // {
        //     title: t("metadata"),
        //     key: "metadata",
        //     dataIndex: "metadata",
        //     align: "center",
        //     sorter: false
        // },
        {
            title: t("rank"),
            key: "rank",
            dataIndex: "rank",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_format"),
            key: "bib_format",
            dataIndex: "bib_format",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_literaryform"),
            key: "bib_literaryform",
            dataIndex: "bib_literaryform",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_title"),
            key: "bib_title",
            dataIndex: "bib_title",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_othertitle"),
            key: "bib_othertitle",
            dataIndex: "bib_othertitle",
            align: "center",
            sorter: false
        },
        {
            title: t("bib_author"),
            key: "bib_author",
            dataIndex: "bib_author",
            align: "center",
            sorter: false,
            render: ((text) => {

            })
        },
        {
            title: t("bib_translator"),
            key: "bib_translator",
            dataIndex: "bib_translator",
            align: "bib_translator",
            sorter: false
        },
        {
            title: t("bib_language"),
            key: "bib_language",
            dataIndex: "bib_language",
            align: "bib_language",
            sorter: false
        },
        {
            title: t("bib_publisher"),
            key: "bib_publisher",
            dataIndex: "bib_publisher",
            align: "bib_publisher",
            sorter: false
        },
        {
            title: t("bib_view_times"),
            key: "bib_view_times",
            dataIndex: "bib_view_times",
            align: "bib_view_times",
            sorter: false
        },
        {
            title: t("bib_borrow_times"),
            key: "bib_borrow_times",
            dataIndex: "bib_borrow_times",
            align: "bib_borrow_times",
            sorter: false
        },
    ];

    // 圖書模式：100a row=0 必填；期刊模式：100a 不必填（自動帶「無」）
    const requestTags = catalogType === "serial" ? [] : ['100a'];

    useEffect(() => {

    }, [])

    /* ── 單一欄位渲染（隱藏 or 可見） ── */
    const renderField = (field, index) => {
        const tagfield = getAnyFormValue(`${field.name}.tagfield`);
        const tagsubfield = getAnyFormValue(`${field.name}.tagsubfield`);
        const ind1 = getAnyFormValue(`${field.name}.ind1_defaultvalue`);
        const ind2 = getAnyFormValue(`${field.name}.ind2_defaultvalue`);
        const libopac = getAnyFormValue(`${field.name}.libopac`);
        const rowVal = getAnyFormValue(`${field.name}.row`);
        const fieldSection = getAnyFormValue(`${field.name}._section`);
        const isHidden = getAnyFormValue(`${field.name}._hidden`);

        const isRequired = requestTags?.find((element) => {
            return element === `${tagfield}${tagsubfield}` && rowVal === 0
        });
        const labelChinese = (libopac || '').split('(')[0].trim();

        return { tagfield, tagsubfield, ind1, ind2, libopac, rowVal, fieldSection, isHidden, isRequired, labelChinese };
    };

    const renderHiddenField = (field) => (
        <Col span={24} key={field.key} style={{ display: 'none' }}>
            <Form.Item name={[field.name, 'tagfield']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'ind1_defaultvalue']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'ind2_defaultvalue']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'tagsubfield']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'row']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'libopac']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, '_section']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, '_hidden']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'content']} hidden><Input /></Form.Item>
        </Col>
    );

    const renderVisibleField = (field, info) => (
        <Col span={section ? 12 : 24} key={field.key}>
            <Form.Item name={[field.name, 'tagfield']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'ind1_defaultvalue']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'ind2_defaultvalue']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'tagsubfield']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'row']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, 'libopac']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, '_section']} hidden><Input /></Form.Item>
            <Form.Item name={[field.name, '_hidden']} hidden><Input /></Form.Item>
            <Form.Item
                labelCol={24}
                wrapperCol={24}
                label={`${info.tagfield} ${info.ind1} ${info.ind2} ${info.tagsubfield}   ${info.libopac}`}
                name={[field.name, 'content']}
                rules={[
                    {
                        required: !!info.isRequired,
                        message: `請填寫${info.labelChinese}`
                    }
                ]}
            >
                <Input />
            </Form.Item>
        </Col>
    );

    return (
        <>
            <Row>
                {/* 只在非 section 模式下渲染 biblionumber / marcdata（簡編由父層 Form 管理） */}
                {!section && (
                <Col span={24}>
                    <Form.Item
                        labelCol={24}
                        wrapperCol={24}
                        {...field}
                        name={[field?.name ?? '', "biblionumber"]}
                        fieldKey={[field?.fieldKey ?? '', "biblionumber"]}
                        hidden={true}
                    >
                        <Input />
                    </Form.Item>
                    <Form.Item
                        labelCol={24}
                        wrapperCol={24}
                        {...field}
                        name={[field?.name ?? '', "marcdata"]}
                        fieldKey={[field?.fieldKey ?? '', "marcdata"]}
                        hidden={true}
                    >
                        <Input />
                    </Form.Item>
                </Col>
                )}
                <Col span={24}>
                    <Form.List
                        {...field}
                        fieldKey={[field?.fieldKey ?? '', 'bookdata']}
                        name={[field?.name ?? '', 'bookdata']}
                    >
                        {(fields, { add, remove }) => {
                            if (section === "cards") {
                                /* ── Cards 模式：在同一個 Form.List 內分組顯示 ── */
                                const requiredFields = [];
                                const optionalFields = [];
                                const hiddenFields = [];

                                fields.forEach((f, index) => {
                                    const info = renderField(f, index);
                                    if (info.isHidden) {
                                        hiddenFields.push({ f, info });
                                    } else if (info.fieldSection === "required") {
                                        requiredFields.push({ f, info });
                                    } else if (info.fieldSection === "optional") {
                                        optionalFields.push({ f, info });
                                    } else {
                                        // 沒有 _section 標記的欄位放入 optional
                                        optionalFields.push({ f, info });
                                    }
                                });

                                const catalogDesc = catalogType === "serial"
                                    ? "期刊編目必填欄位，包含 ISSN、書名、刊期等。"
                                    : "圖書編目必填欄位，包含 ISBN、書名、主要作者等。";

                                return (
                                    <>
                                        {/* 隱藏欄位（保留資料） */}
                                        {hiddenFields.map(({ f }) => renderHiddenField(f))}

                                        {/* ── 必填書目資料 Card ── */}
                                        <Card style={{ marginBottom: '1.5em' }}>
                                            <CardHeader>
                                                <CardTitle className="text-lg">
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                        <IconClipboardCheck size={18} style={{ color: '#ef4444' }} /> 必填書目資料
                                                    </span>
                                                </CardTitle>
                                                <CardDescription>{catalogDesc}</CardDescription>
                                            </CardHeader>
                                            <CardContent>
                                                <Row gutter={[16, 0]}>
                                                    {requiredFields.map(({ f, info }) => renderVisibleField(f, info))}
                                                </Row>
                                            </CardContent>
                                        </Card>

                                        {/* ── 補充書目資料（選填） Card ── */}
                                        <Card>
                                            <CardHeader>
                                                <CardTitle className="text-lg">
                                                    <span style={{ display: 'inline-flex', alignItems: 'center', gap: 8 }}>
                                                        <IconFileEarmarkText size={18} style={{ color: '#64748b' }} /> 補充書目資料（選填）
                                                    </span>
                                                </CardTitle>
                                                <CardDescription>版次、叢書名、附註等補充資訊。</CardDescription>
                                            </CardHeader>
                                            <CardContent>
                                                <Row gutter={[16, 0]}>
                                                    {optionalFields.map(({ f, info }) => renderVisibleField(f, info))}
                                                </Row>
                                            </CardContent>
                                        </Card>
                                    </>
                                );
                            }

                            /* ── 一般模式（詳編 / 單一 section） ── */
                            return (
                                <Row gutter={[16, 0]}>
                                    {fields.map((field, index) => {
                                        const info = renderField(field, index);
                                        const belongsToSection = !section || info.fieldSection === section;
                                        const shouldHide = !belongsToSection || !!info.isHidden;

                                        if (shouldHide) {
                                            return renderHiddenField(field);
                                        }
                                        return renderVisibleField(field, info);
                                    })}
                                </Row>
                            );
                        }}
                    </Form.List>
                </Col>
            </Row>
        </>
    );
};





export default GeneralBibliographicEditModeForm;
